module.exports = __webpack_public_path__ + "img/login-img-2.72084c58.svg";